import { render, staticRenderFns } from "./BaseNumberInput.vue?vue&type=template&id=2d79078f&"
import script from "./BaseNumberInput.vue?vue&type=script&lang=js&"
export * from "./BaseNumberInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports